import { scaleSamples } from 'shared/luox/src/javascript/rows';
import {
  calculate,
  relativeToAbsolute,
} from 'shared/luox/src/javascript/calculations';

export const getLuoxData = (spdWavelengths, spdValues) => {
  let calculatedResults;
  const luoxInput = spdWavelengths.map((wavelength, index) => {
    return [wavelength, spdValues[index]];
  });
  // const scaledLuoxInput = scaleSamples(luoxInput, 'metresq', 'milliwatt');
  if (luoxInput.length !== 0) {
    calculatedResults = calculate(luoxInput, 1);
  }
  const luoxData = {
    luoxInput: luoxInput,
    luoxOutput: calculatedResults,
  };
  return luoxData;
};

export const convertLuoxData = (luoxInput, luoxUnits) => {
  const {
    absoluteOrRelative,
    radianceOrIrradiance,
    powerScale,
    areaScale,
    relativePower,
  } = luoxUnits;

  let calculatedResults;
  const areaScaleUnit = ['mm²', 'mm2'].includes(areaScale)
    ? 'millimetresq'
    : ['cm²', 'cm2'].includes(areaScale)
    ? 'centimetresq'
    : 'metresq';
  const powerScaleUnit =
    powerScale === 'µW'
      ? 'microwatt'
      : powerScale === 'mW'
      ? 'milliwatt'
      : 'watt';

  if (absoluteOrRelative.toLowerCase() === 'absolute') {
    const scaledLuoxInput = scaleSamples(
      luoxInput,
      areaScaleUnit,
      powerScaleUnit
    );
    if (scaledLuoxInput.length !== 0) {
      calculatedResults = calculate(scaledLuoxInput, 1);
    }
  } else if (absoluteOrRelative.toLowerCase() === 'relative') {
    const relativeToAbsoluteOutput = relativeToAbsolute(luoxInput, 1, {
      0: relativePower,
    });
    if (relativeToAbsoluteOutput.length !== 0) {
      calculatedResults = calculate(relativeToAbsoluteOutput, 1);
    }
  }
  const luoxData = {
    luoxInput: luoxInput,
    luoxOutput: calculatedResults,
  };
  return luoxData;
};
